import recipientStoreMutations from './recipientStore/recipientStoreMutations'
import recipientStoreActions from './recipientStore/recipientStoreActions'
import getRecipientStoreDefaultState from './recipientStore/recipientStoreDefaultState'

let state = getRecipientStoreDefaultState()

export const recipientStore = {
  namespaced: true,
  state,
  mutations: recipientStoreMutations,
  actions: recipientStoreActions
}
